import { ButtonProps } from '../components/Button';

export interface ActionButton {
	/** text to display on button */
	text: string;
	/** button click event */
	onClick: () => void;
	/** props to pass down to button */
	props: Omit<ButtonProps, 'onClick'>;
}
